import { Stack } from '@mui/material'
import React from 'react'
import { useCookies } from 'react-cookie'
import { Outlet } from 'react-router-dom'
import NavBar from '../../components/Navbar'
import SideMenu from '../../components/SideMenu'
import { awsConfig, commonConfig } from '../../config'
import Styles from '../../style/theme'

function Main() {
  const [cookies] = useCookies()
  const token = cookies?.token
  if (!token) window.location.href = `${awsConfig.cognitoDomain}/login?client_id=${awsConfig.clientId}&response_type=token&scope=openid+profile&redirect_uri=${commonConfig.domain}`

  return (
    <Stack
      sx={{
        backgroundColor: Styles.Color.PrimaryGray1,
        height: '100vh',
      }}>
      <NavBar />
      <Stack flexDirection="row" flex="1">
        <Stack sx={{ width: '160px', backgroundColor: '#F6F9FB' }}>
          <SideMenu />
        </Stack>
        <Stack flexDirection="row" flex="1">
          <Outlet />
        </Stack>
      </Stack>
    </Stack>
  )
}

export default Main
